import { styled } from '@mui/material';

import { I18nResources, useI18n } from '@app-velocity/i18n';

export type SingleStatProps = {
  value: string | number;
  label: I18nResources;
};

const StyledStat = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const StyledValue = styled('span')({
  linHeight: 1.33,
  fontSize: 24,
  fontWeight: 700,
  color: 'var(--text-text-primary-color)',
});

const StyledLabel = styled('span')({
  lineHeight: 1.5,
  fontSize: 12,
  fontWeight: 400,
  color: 'var(--text-text-secondary-color)',
});

export const SingleStat = ({ value, label }: SingleStatProps) => {
  const { t } = useI18n();

  return (
    <StyledStat>
      <StyledValue>{value}</StyledValue>
      <StyledLabel>{t(label)}</StyledLabel>
    </StyledStat>
  );
};
